import React, {useEffect, useState} from "react";
import {
    Button, Card,
    Field, Input,
    Menu, MenuList, MenuPopover, MenuTrigger, Select,
    Skeleton, Toolbar, ToolbarButton,
} from "@fluentui/react-components";
import {Link, useNavigate, useParams} from "react-router-dom";
import {CardWrapCentered} from "../../../styled/CardWrapCentered";
import {ArrowLeftRegular, MoreHorizontal24Filled} from "@fluentui/react-icons";
import {DeleteMenuItem} from "../../../components/atoms/DeleteMenuItem";
import {useEntityShow} from "../../../hooks/useEntityShow";
import {apiPost} from "../../../api/client";
import {useApartmentsList} from "../../../hooks/useApartmentsList";

export const AccommodationReservationEdit: React.FC = () => {
    const apartments = useApartmentsList();

    const navigate = useNavigate();
    const {id} = useParams();
    const data = useEntityShow('apartment_reservations', id);

    const [name, setName] = useState("");
    const [apartmentId, setApartmentId] = useState(0);
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [note, setNote] = useState("");

    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        setName(data?.name);
        setApartmentId(data?.apartment_id);
        setEmail(data?.email);
        setPhone(data?.phone);
        setDateFrom(data?.date_from);
        setDateTo(data?.date_to);
        setNote(data?.note);
    }, [data]);

    if (!id) {
        navigate('/accommodation/reservations');
        return <Skeleton>...</Skeleton>;
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true)

        apiPost('apartment_reservations/edit.php', {
            id: id,
            name: name,
            apartment_id: apartmentId,
            email: email,
            phone: phone,
            date_from: dateFrom,
            date_to: dateTo,
            note: note
        }).then((response) => {
            console.log(response);
            navigate('/accommodation')
        }).catch((error) => {

        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <CardWrapCentered>
            <Card>
                <Toolbar>
                    <ToolbarButton icon={<ArrowLeftRegular/>}>
                        <Link to={'/accommodation'}>Zpět</Link>
                    </ToolbarButton>
                    <div style={{flex: 1}}/>
                    <Menu>
                        <MenuTrigger>
                            <ToolbarButton aria-label="More" icon={<MoreHorizontal24Filled/>}/>
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <DeleteMenuItem entity={'apartment_reservations'} id={id}
                                                returnPath={'/accommodation'}/>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                </Toolbar>
                <h1>Upravit rezervaci #{id}</h1>
                <form onSubmit={handleSubmit}>
                    <Field label={'Od'}>
                        <Input type={'date'} required value={dateFrom} onChange={(e) => setDateFrom(e.target.value)}/>
                    </Field>
                    <Field label={'Do'}>
                        <Input type={'date'} required value={dateTo} onChange={(e) => setDateTo(e.target.value)}/>
                    </Field>
                    <Field label={'Jméno'}>
                        <Input type={'text'} required value={name} onChange={(e) => setName(e.target.value)}
                               autoFocus={true}/>
                    </Field>
                    <Field label={'Apartmán'}>
                        <Select required value={apartmentId} onChange={(e) => setApartmentId(parseInt(e.target.value))}>
                            <option key={0}></option>
                            {apartments?.map((apartment: any) => (
                                <option key={apartment.id} value={apartment.id}>{apartment.name}</option>
                            ))}
                        </Select>
                    </Field>
                    <Field label={'Email'}>
                        <Input type={'email'} value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </Field>
                    <Field label={'Telefon'}>
                        <Input type={'text'} value={phone} onChange={(e) => setPhone(e.target.value)}/>
                    </Field>
                    <Field label={'Poznámka'}>
                        <Input type={'text'} value={note} onChange={(e) => setNote(e.target.value)}/>
                    </Field>
                    <div style={{height: '1rem'}}></div>
                    <Button type={'submit'}
                            disabled={name?.length < 4 || dateFrom?.length < 4 || dateTo?.length < 4 || dateFrom > dateTo || loading}
                            size={'large'}>
                        {loading ? 'Ukládám...' : 'Uložit'}
                    </Button>
                </form>
            </Card>
        </CardWrapCentered>
    )
}